import { render } from "./SelectCategory.vue?vue&type=template&id=83bbf530&scoped=true&ts=true"
import script from "./SelectCategory.vue?vue&type=script&lang=ts"
export * from "./SelectCategory.vue?vue&type=script&lang=ts"

import "./SelectCategory.vue?vue&type=style&index=0&id=83bbf530&lang=scss&scoped=true"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83bbf530"]])

export default __exports__